/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface DeleteTagModalState {
    isOpen: boolean;

    data: {
        id: number;

        name: string;

        documentId: number;
    } | null;
}

export interface DeleteTagModalDispatchParams {
    id: number;

    name: string;

    documentId: number;
}

const initialState: DeleteTagModalState = {
    isOpen: false,
    data: null,
};

export const deleteTagModalSlice = createSlice({
    name: 'delete-tag-modal',
    initialState,
    reducers: {
        open(state: DeleteTagModalState, action: PayloadAction<DeleteTagModalDispatchParams>) {
            state.isOpen = true;
            state.data = action.payload;
        },
        close(state: DeleteTagModalState) {
            state.isOpen = false;
            state.data = null;
        },
    },
});
